export enum Characters {
  DOT = '.',
  COMMA = ',',
  QUESTION = '?',
  AMPERSAND = '&',
  APOSTROPHE = '\'',
  SLASH = '/',
  AT = '@',
  EQUAL = '=',
  EXCLAMATION = '!',
  PLUS = '+',
  MINUS = '-',
  OPEN_BRACKET = '(',
  CLOSE_BRACKET = ')',
  COLON = ':',
  DOUBLE_QUOTE = '\"',
  ZERO = '0',
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
  EIGHT = '8',
  NINE = '9'
}
